// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as AdjustFareHomeCmp from "./AdjustFareHomeCmp.bs.js";
import * as AdjustFareDataMachine from "../../app/repo/AdjustFareDataMachine.bs.js";
import * as AdjustFareStateMachine from "./AdjustFareStateMachine.bs.js";
import * as AdjustFareAssetsManager from "../assets/AdjustFareAssetsManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

AdjustFareAssetsManager.importCss(undefined);

function AdjustFareContainer(Props) {
  var orderId = Props.orderId;
  var match = React.useReducer(AdjustFareStateMachine.reducer, AdjustFareStateMachine.intitial_state);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetCurrentFare */1,
                current_fare_details: {
                  TAG: /* Loading */0,
                  _0: undefined
                }
              });
          Curry._1(dispatch, {
                TAG: /* UpdateNewFareDetails */2,
                new_fare_datails: {
                  TAG: /* Loading */0,
                  _0: undefined
                }
              });
          Curry._1(dispatch, {
                TAG: /* SetIncidentalChargesTypes */4,
                incident_charges_types: {
                  TAG: /* Loading */0,
                  _0: undefined
                }
              });
          AdjustFareDataMachine.fetchFare(orderId, /* Current */3, (function (current_fare_details) {
                  Curry._1(dispatch, {
                        TAG: /* SetCurrentFare */1,
                        current_fare_details: {
                          TAG: /* Live */1,
                          _0: current_fare_details
                        }
                      });
                  return Curry._1(dispatch, {
                              TAG: /* UpdateNewFareDetails */2,
                              new_fare_datails: {
                                TAG: /* Live */1,
                                _0: current_fare_details
                              }
                            });
                }), (function (error) {
                  Curry._1(dispatch, {
                        TAG: /* SetCurrentFare */1,
                        current_fare_details: {
                          TAG: /* Error */2,
                          _0: error
                        }
                      });
                  return Curry._1(dispatch, {
                              TAG: /* UpdateNewFareDetails */2,
                              new_fare_datails: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), country);
          AdjustFareDataMachine.getIncidentalChargeTypes((function (incident_charges_types) {
                  return Curry._1(dispatch, {
                              TAG: /* SetIncidentalChargesTypes */4,
                              incident_charges_types: {
                                TAG: /* Live */1,
                                _0: incident_charges_types
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetIncidentalChargesTypes */4,
                              incident_charges_types: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), country);
          
        }), []);
  var match$2 = state.current_fare_details;
  var match$3 = state.incident_charges_types;
  var tmp;
  var exit = 0;
  var error;
  var exit$1 = 0;
  if (typeof match$2 === "number") {
    exit$1 = 3;
  } else {
    switch (match$2.TAG | 0) {
      case /* Loading */0 :
          exit$1 = 3;
          break;
      case /* Live */1 :
          if (typeof match$3 === "number") {
            exit = 1;
          } else {
            switch (match$3.TAG | 0) {
              case /* Loading */0 :
                  exit = 1;
                  break;
              case /* Live */1 :
                  tmp = React.createElement(AdjustFareHomeCmp.make, {
                        state: state,
                        dispatch: dispatch
                      });
                  break;
              case /* Error */2 :
                  exit$1 = 3;
                  break;
              
            }
          }
          break;
      case /* Error */2 :
          error = match$2._0;
          exit = 2;
          break;
      
    }
  }
  if (exit$1 === 3) {
    if (typeof match$3 === "number" || match$3.TAG !== /* Error */2) {
      exit = 1;
    } else {
      error = match$3._0;
      exit = 2;
    }
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case 2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: error
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, tmp);
}

var make = AdjustFareContainer;

export {
  make ,
  
}
/*  Not a pure module */
